import VueI18n from 'vue-i18n'
import langs from './langs'
import Vue from 'vue'
import { get } from './utils/http'
import store from './store'
Vue.use(VueI18n)
const i18n = new VueI18n(langs)

// i18n.loadModules = (lang) => {
//   store.commit('loading', true)
//   get(
//     '/cdb/setting/getTranslation',
//     {
//       'channel': 'h5',
//       'agentId': process.env.VUE_APP_PTID,
//       'language': lang,
//       'keySplit': true
//     },
//     (resp) => {
//       i18n.setLocaleMessage(lang, { ...langs.messages[lang], ...resp.data })
//       i18n.locale = lang
//       store.commit('lang', lang)
//       store.commit('loading', false)
//     },
//     (error) => {
//       store.commit('loading', false)
//       console.log(error)
//     }
//   )
// }

// i18n.loadLangs = () => {
//   store.commit('loading', true)
//   get(
//     '/cdb/setting/getLanguageList',
//     {
//       'channel': 'h5',
//       'agentId': process.env.VUE_APP_PTID
//     },
//     (resp) => {
//       let temp = resp.resMap.map((e, index) => {
//         e.index = index
//         return e
//       })
//       store.commit('localeArr', temp)
//       store.commit('loading', false)
//     },
//     (error) => {
//       store.commit('loading', false)
//       console.log(error)
//     }
//   )
// }
export default i18n
